import { render, staticRenderFns } from "./LaboralRequestForm.vue?vue&type=template&id=399d0f83&"
import script from "./LaboralRequestForm.vue?vue&type=script&lang=js&"
export * from "./LaboralRequestForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports